import api from './api';

export const codeExecutionService = {
  // Execute Python code
  executeCode: async (code, input = '') => {
    const response = await api.post('/execute', { code, input });
    return response.data;
  },
  
  // Validate code against test cases
  validateCode: async (code, testCases) => {
    const response = await api.post('/execute/validate', { code, testCases });
    return response.data;
  },
};

export default codeExecutionService;




